module.exports = __webpack_public_path__ + "img/recharge3.57bba670.png";